import { createFileRoute, notFound } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { RequireAccess } from '@/features/auth/RequireAccess';
import { hasDetailedAccess } from '@/features/auth/roles';
import { isMetricKey } from '@/features/metrics/metrics';
import { PlaceholderPanel } from '@/shared/ui/PlaceholderPanel';

export const Route = createFileRoute('/_app/wskazniki/$metric')({
  loader: ({ params }) => {
    if (!isMetricKey(params.metric)) throw notFound();
    return { metric: params.metric };
  },
  component: MetricRoute,
});

function MetricRoute() {
  return (
    <RequireAccess allow={hasDetailedAccess}>
      <MetricContent />
    </RequireAccess>
  );
}

function MetricContent() {
  const { t } = useTranslation();
  const { metric } = Route.useLoaderData();

  return (
    <PlaceholderPanel eyebrow={t('nav.demographics')} title={t(`metrics.${metric}`)}>
      <p>{t('pages.metricBody')}</p>
    </PlaceholderPanel>
  );
}
